export const meta = {
  id: 'A11',
  slug: 'registrar-evidencia',
  title: 'Como registrar uma Evidência',
  description: 'Registre uma aplicação prática, comportamento ou resultado que demonstre seu desenvolvimento.',
  profile: 'student',
  category: 'evidencias',
  type: 'task',
  status: 'published',
  order: 150,
  keywords: ['evidência', 'comprovação', 'prática', 'atividade', 'link', 'resultado', 'mentor'],
  previous: 'A10',
  next: 'A12',
  related: ['A03', 'A12', 'A13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como registrar uma Evidência

Uma Evidência registra algo que demonstra sua **aplicação prática ou desenvolvimento**. Ela ajuda a transformar aprendizado em algo observável e acompanhável.

## O que pode ser uma Evidência

Você pode registrar uma descrição do que realizou, um resultado obtido, um link ou outra informação disponível no formulário que ajude a demonstrar sua aplicação.

## Como registrar

<Steps>
  <Step title="Acesse Evidências">
    Abra sua área de Evidências e selecione a ação para criar um novo registro.
  </Step>
  <Step title="Descreva o que aconteceu">
    Explique de forma específica o que você fez, em qual contexto e qual resultado percebeu.
  </Step>
  <Step title="Adicione o link ou informação disponível">
    Inclua os dados complementares solicitados quando forem relevantes.
  </Step>
  <Step title="Revise e salve">
    Depois de salvar, acompanhe o registro e eventual avaliação ou feedback do Mentor.
  </Step>
</Steps>

<HelpImage alt="Cadastro de nova Evidência" pendingId="A11.2" />

## Depois de salvar

Quando permitido pela tela, você pode editar, excluir ou reorganizar seus registros. O Mentor responsável pode utilizar Evidências no acompanhamento do seu desenvolvimento.

<Callout type="concept">
  Evidências são especialmente úteis para demonstrar **Habilidade** e **Atitude**: não apenas o que você sabe, mas o que consegue aplicar e demonstrar no comportamento.
</Callout>

<Callout type="tip">
  Prefira descrições concretas. “Apliquei a técnica na reunião e consegui chegar a um acordo com três áreas” ensina mais sobre sua evolução do que “foi bom”.
</Callout>
